import { ButtonModule } from 'primeng/button';
import { AfterViewInit, Component } from '@angular/core';
import { CustomTableComponent } from '../../../utils/custom-table/custom-table.component';
import { Device } from '../../../models/device';
import { DatepickerComponent } from "../../../utils/datepicker/datepicker.component";
import { DevicesService } from '../../../services/devices.service';
import { ReportsServicesService } from '../../../services/reports-services.service';
import { jwtDecode } from 'jwt-decode';
import { LoaderComponent } from "../../../utils/loader/loader.component";
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../../theme.service';

@Component({
    selector: 'app-logs',
    imports: [ButtonModule, CustomTableComponent, DatepickerComponent, LoaderComponent, FormsModule, InputTextModule, SelectModule],
    templateUrl: './logs.component.html',
    styleUrl: './logs.component.scss'
})
export class LogsComponent implements AfterViewInit {
  loading=false;
   logs:any[] =[];
   allCards:any=[];
   headers:any[] =[
    { key: "date", textHeader: "Fecha", visible: true, type: "fullTime" },
    { key: "type", textHeader: "Modificación", visible: true, type: "string" },
    { key: "card", textHeader: "Tarjeta", visible: true, type: "string" },
    { key: "description", textHeader: "Descripción", visible: true, type: "html" },
    { key: "user", textHeader: "Usuario", visible: true, type: "string" },
   ];
   
   cards = [
    {
      value: -1,
      text: 'Todas'
    },
  ];
   fromDate!: Date;
   toDate!: Date;
   fromDateRequest!: Date;
   toDateRequest!: Date;
   selectedCard=-1;
   data: any;
   tokenAuth: any;

   ngOnInit(){
    this.getAllCards();
   }
   
   constructor(private service: ReportsServicesService, private deviceService: DevicesService, private titleService:Title, private themeService:ThemeService
      
   ) {
     this.titleService.setTitle("Bitácora - Movimientos");
     this.themeService.setTitle("Bitácora de Movimientos");
   
    this.data = JSON.parse(localStorage.getItem('data')!); 
  }
  ngAfterViewInit(): void {
   this.getLogs();
  }

   setDatesOnFilter(event: any) {
    this.fromDate = event.from;
    this.toDate = event.to;
  }

  changeDeviceFilter(event: any, isFromCard: boolean) {
    this.selectedCard = event.value;
  }

  

  getAllCards() {

    this.deviceService.loadDevices(this.data.Client_number, this.data.User_id, '',true).subscribe({
      next: (resp: any) => {
        this.allCards = resp;
        resp.forEach((element: any) => {
          this.cards.push({
            value: element.cardId,
            text: (element.cardId.toString().padStart(5, "0")) + ' - ' + element.description
          });
         
        });

      },
      error: (err: any) => {
        this.allCards = [];
        this.loading = false;
      }

    })
  }

  getLogs() {
    this.loading = true;
    this.fromDateRequest = new Date(this.fromDate);
    this.toDateRequest = new Date(this.toDate);
    let searchType=this.selectedCard==-1?1:2
    this.service.getLogs(this.data.Client_id, this.fromDateRequest, this.toDateRequest, this.selectedCard, searchType).subscribe({
      next: (resp: any) => {
       
        let logsFounded = resp;
        resp.forEach((log:any) => {
          log.type=log.card==null || log.card=='' ?'Por Cliente':'Por Tarjeta' ,
          log.card = log.card==null || log.card=='' ?"" :log.card.padStart(5,"0");
        });
        this.logs=resp;
    
        this.loading = false;
      },
      error: (err: any) => {
        this.logs = [];
        this.loading = false;
      }
    });
  }
  
}
